// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InstamotionLeadCTAs_wrapper__SeI12","innerWrapper":"InstamotionLeadCTAs_innerWrapper__iZOfg"};